export default __webpack_public_path__ + "static/media/SocialMediaIntegration.4b1c2d5e.png";